import { Clock } from 'lucide-react';
import type { AvailabilityRule } from '../hooks/useAvailability';

const DAYS_OF_WEEK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

interface StandardWeekRowProps {
  availability: AvailabilityRule[];
  onEditDay: (dayOfWeek: number) => void;
}

export function StandardWeekRow({ availability, onEditDay }: StandardWeekRowProps) {
  // Get the recurring rule for a specific day of week
  const getRuleForDay = (dayOfWeek: number): AvailabilityRule | null => {
    return availability.find((rule) => rule.dayOfWeek === dayOfWeek) ?? null;
  };

  return (
    <div className="bg-background-subtle rounded-lg border border-border p-3">
      <div className="flex items-center gap-2 mb-3">
        <Clock className="h-4 w-4 text-foreground-muted" />
        <span className="text-sm font-medium text-foreground">Standard Week</span>
        <span className="text-xs text-foreground-muted">(recurring schedule)</span>
      </div>

      <div className="grid grid-cols-7 gap-1">
        {DAYS_OF_WEEK.map((dayName, dayIndex) => {
          const rule = getRuleForDay(dayIndex);
          const hasHours = rule !== null;

          return (
            <button
              type="button"
              key={dayIndex}
              onClick={() => onEditDay(dayIndex)}
              className={`
                flex flex-col items-center p-2 rounded-md text-xs transition-colors
                ${hasHours
                  ? 'bg-success/10 hover:bg-success/20 border border-success/30'
                  : 'bg-background hover:bg-background-muted border border-border'
                }
              `}
            >
              <span className={`font-medium ${hasHours ? 'text-success-foreground' : 'text-foreground-muted'}`}>
                {dayName}
              </span>
              <span className={`mt-0.5 ${hasHours ? 'text-success-foreground' : 'text-foreground-muted'}`}>
                {hasHours ? `${rule.startTime.substring(0, 5)}-${rule.endTime.substring(0, 5)}` : 'Off'}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
